import { List } from '@material-ui/core'
import React from 'react'
import { AnnouncementListItemModel } from '../announcementListItem/announcementListItem.model'
import AnnouncementListItem from '../announcementListItem/announcementListItem'
import { generateUniqueKey } from '../../../helpers'

export interface AnnouncementListProps {
  announcementItems: AnnouncementListItemModel[]
}

const AnnouncementList: React.FC<AnnouncementListProps> = ({ announcementItems }) => {
  return (
    <List dense={true}>
      {announcementItems.map(item => (
        <AnnouncementListItem
          key={generateUniqueKey('announcementListItem')}
          listIsEmpty={item.listIsEmpty}
          emptyMessage={item.emptyMessage}
          avatarText={item.avatarText}
          primaryText={item.primaryText}
          secondaryText={item.secondaryText}
          actionText={item.actionText}
          hasPermission={item.hasPermission}
          itemType={item.itemType}
          onClickHandler={item.onClickHandler}
        />
      ))}
    </List>
  )
}

export default AnnouncementList
